import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { doLogin } from '../../services/AuthService';
import AuthLayout from '../../components/Auth/AuthLayout';
import AuthField from '../../components/Auth/AuthField';
import { AppButton } from '../../components/AppButton/AppButton';

const emailIcon = (
    <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
    </svg>
);

const passwordIcon = (
    <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
    </svg>
);

function Login() {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    function onChangeInput(event) {
        if (event.target.id === 'email') setEmail(event.target.value);
        else setPassword(event.target.value);
    }

    function onSubmit(event) {
        event.preventDefault();

        doLogin(email, password)
            .then((response) => {
                localStorage.setItem('token', response.token);
                history.push('/dashboard');
            })
            .catch((err) => {
                console.error(err.response ? err.response.data : err.message);
                setError('Invalid email or password.');
            });
    }

    return (
        <AuthLayout
            title="Sign in"
            description="Access the NeuraTrader admin dashboard."
        >
            <form onSubmit={onSubmit}>
                <AuthField
                    id="email"
                    label="Email"
                    type="email"
                    placeholder="you@company.com"
                    icon={emailIcon}
                    autoFocus
                    onChange={onChangeInput}
                />
                <AuthField
                    id="password"
                    label="Password"
                    type="password"
                    placeholder="Enter your password"
                    icon={passwordIcon}
                    onChange={onChangeInput}
                />

                <AppButton type="submit" variant="primary" size="lg" fullWidth>
                    Sign In
                </AppButton>

                {error ? <div className="auth-alert auth-alert-error">{error}</div> : null}
            </form>
        </AuthLayout>
    );
}

export default Login;